import { parseEmbedTheme } from '../../../../packages/survey-core/src/embed-theme';
import type { User, Workspace } from '@responsedock/types';
import type { EmbeddedContext, EmbeddedTheme } from '../store/auth';

const STORAGE_KEY = 'responsedock.embed-session.v1';

export interface StoredEmbedSession {
  token: string;
  user: User;
  workspaces: Workspace[];
  embed: EmbeddedContext;
}

function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch {
    return null;
  }
}

export function readStoredEmbedSession(): StoredEmbedSession | null {
  const raw = storage()?.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as StoredEmbedSession;
    if (!value.token || !value.user?.id || !value.embed?.workspaceId || !value.embed.allowedOrigin) return null;
    return { ...value, embed: { ...value.embed, theme: parseEmbedTheme(value.embed.theme ?? {}) } };
  } catch {
    clearStoredEmbedSession();
    return null;
  }
}

export function storeEmbedSession(value: StoredEmbedSession): void {
  storage()?.setItem(STORAGE_KEY, JSON.stringify(value));
}

export function updateStoredEmbedTheme(theme: EmbeddedTheme): void {
  const current = readStoredEmbedSession();
  if (current) storeEmbedSession({ ...current, embed: { ...current.embed, theme } });
}

export function clearStoredEmbedSession(): void {
  storage()?.removeItem(STORAGE_KEY);
}
